'use server'

import { getServerSession } from 'next-auth'
import { ThreadStatus, type Thread } from '@/prisma/generated'

import db from '@/lib/db'
import { authOptions } from '../auth/server'

export const getThreadById = async (threadId: string) => {
  const session = await getServerSession(authOptions)
  if (!session?.user) throw new Error('Unauthorized')
  const thread = await db?.thread.findUnique({
    where: { id: threadId },
    include: {
      users: true,
      project: true,
      checkpoints: true,
      checkpointBlobs: true,
      checkpointWrites: true
    }
  })
  if (thread?.users.find(user => user.id === session?.user.id)) return thread
  else throw new Error('Forbidden')
}

export const createNewThread = async ({
  projectId,
  title,
  description,
  gitHubIssue,
  pullRequest
}: {
  projectId: string
  title?: string
  description?: string | null
  gitHubIssue?: number | null
  pullRequest?: number | null
}) => {
  const session = await getServerSession(authOptions)
  if (!session?.user) throw new Error('Unauthorized')
  return db?.thread.create({
    data: {
      users: { connect: [{ id: session.user.id }] },
      project: { connect: { id: projectId } },
      title,
      description,
      gitHubIssue,
      pullRequest,
      status: ThreadStatus.Started
    },
    include: { users: true }
  })
}

export const updateThread = async ({
  id,
  slug,
  title,
  description,
  gitHubIssue,
  pullRequest,
  status,
  currentStepIndex,
  stage,
  archived,
  plan,
  filesViewed
}: // fileEdits,
Partial<Thread>) => {
  const session = await getServerSession(authOptions)
  if (!session?.user) throw new Error('Unauthorized')
  return db?.thread.update({
    where: { id },
    data: {
      slug,
      title,
      description,
      gitHubIssue,
      pullRequest,
      stage,
      archived,
      // fileEdits,
      filesViewed: filesViewed ? JSON.stringify(filesViewed) : undefined,
      status,
      plan: plan ? JSON.stringify(plan) : undefined,
      currentStepIndex
    }
  })
}
